import styled from 'styled-components';

export const Paragraph = styled.p`
    margin-top: 0;
    font-weight: 700;
`;
